import React from 'react';

import PlusIcon from '@ps-design-system/icons/Plus/Plus32';

import { useUploadModal } from '../context/UploadModalContext';

const UploaderMediaButton = () => {
  const { openMediaModal } = useUploadModal();

  return (
    <button type="button" className='uploader-media-button' onClick={openMediaModal} aria-label="Upload media" data-testing-id="upload-modal-open">
      <PlusIcon />
    </button>
  );
};

export default UploaderMediaButton;
